import { render, staticRenderFns } from "./EmployeeDirectoryPageMenu.vue?vue&type=template&id=cf229056&scoped=true"
import script from "./EmployeeDirectoryPageMenu.vue?vue&type=script&lang=js"
export * from "./EmployeeDirectoryPageMenu.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDirectoryPageMenu.vue?vue&type=style&index=0&id=cf229056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf229056",
  null
  
)

export default component.exports